export default {
  index: [
    {
      path: '/zkhehuofhjc',
      component: resolve => require(['./zkhehuofhjcIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/zkhehuofhjc/_router.js